// OP-3605 — Histórico de solicitações (ESL1): todos os pedidos, inclusive os
// que já fecharam, com o despachado por linha. Tela de consulta.
import { FC } from 'react'
import { ListaSolicitacoes } from '../Fila/ListaSolicitacoes'

export const EstoqueHistorico: FC = () => <ListaSolicitacoes modo="historico" />

export default EstoqueHistorico
